import React, { useState } from 'react';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import Button from '../Button';

function ReturnTopButton()
{
    const [isVisible, setIsVisible] = useState(false);

    const goTop = () =>
    {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    window.addEventListener('scroll', () =>
    {
        if (window.scrollY > 100)
        {
            setIsVisible(true);
        }
        else
        {
            setIsVisible(false);
        }
    });

    return (
        <Button onClick={goTop} iconMargin="tw-mr-0" className={`tw-right-3 tw-p-6 tw-transition-all tw-fixed ${isVisible ? 'tw-top-[calc(100vh-100px)]' : 'tw-top-[100vh]'}`} icon={faChevronUp} />
    );
}

export default ReturnTopButton;
